export enum SurgeryBenefits {
    INPATIENT = "Inpatient surgery",
    OUTPATIENT_HOSPITAL = "Outpatient surgery (performed in a hospital or ambulatory surgical center)",
    OUTPATIENT_PHYSICIAN_OFFICE = "Outpatient surgery (performed in a physician office)",
    GENERAL_ANESTHESIA = "General anesthesia",
    SECOND_OPINION = "Second opinion"
}